export default __webpack_public_path__ + "static/media/manual08.0913bd9b.png";